// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2xhp9","addWidgetButton":"Header_addWidgetButton__1B8Kn","dashboardTabs":"Header_dashboardTabs__1AvKP","active":"Header_active__FPvps"};